import { render, staticRenderFns } from "./creditNoteDataTable.vue?vue&type=template&id=0823d7c2&"
import script from "./creditNoteDataTable.vue?vue&type=script&lang=js&"
export * from "./creditNoteDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports